import React from 'react'

const IconAttributeLevel = () => {
  return (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="0.5" width="11" height="11" stroke="#ADADAC" />
      <path d="M7.25181 7.803H4.74981L4.33581 9H3.01281L5.27181 2.709H6.73881L8.99781 9H7.66581L7.25181 7.803ZM6.90981 6.795L6.00081 4.167L5.09181 6.795H6.90981Z" fill="black" />
    </svg>
  )
}

export default IconAttributeLevel
